<template>
    <div class="modal hide fade in" id="modalObservaciones" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title label-black">Observaciones</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">

                  <div class="row">
                        <div class="form-group col-12">
                            <label class="label-black">Observaciones / Contenido:</label>
                            <textarea id="nombreSede_div" class="form-control" v-model="ObservacionesArchivo" rows="5"/>
                        </div>
                  </div>   
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-custom" id="botonAceptar" >Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'
import router from '@/router/index'

export default {
    data(){
        return{
            ObservacionesArchivo: ""
            }
    },
    props: {
        Id: {
            type: Number,
            default: 0
        },
        Detalle: ""
    },
    methods: {
        Mostrar: function () {
            this.ObservacionesArchivo = this.Detalle;
        $('#modalObservaciones').modal('show');
        $('#closeModal').unbind('click').click(this.ModalClose);
        $('#botonAceptar').unbind('click').click(this.ModalClose);
        },
        ModalClose: function(){
            $('#modalObservaciones').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('dialogo', {'Texto': this.ObservacionesArchivo, 'Estatus': false, "Id": this.Id});
        }
    },
    mounted(){
        this.Mostrar();
    }
}

</script>
<style scoped>
    .modal-content {
      background-color:  #7e7f74;
    }
    .modal-header {
        background-color:  #007573;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>


// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/ComentarioSolicitud.vue